import { render } from "./AddEmpruntPage.vue?vue&type=template&id=411c224f&ts=true"
import script from "./AddEmpruntPage.vue?vue&type=script&lang=ts"
export * from "./AddEmpruntPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__